<template>
    <page-view title="添加包组">
        <template slot="action">
            <a-button class="ml-1 mr-1" type="primary" icon="plus-circle" @click="onSave">保存包组
            </a-button>
        </template>
        <a-card>
            <a-form :form="packForm" class="pick-100">
                <a-row type="flex" justify="space-between" class="form-input about">
                    <a-col :span="11">
                        <a-form-item label="包组名称">
                            <a-input placeholder="包组名称"
                                     v-decorator="['packName',{initialValue: xmmc, rules: [{ required: true, message: '请输入包组名称' ,whitespace:true}]}]"></a-input>
                        </a-form-item>
                    </a-col>
<!--                    @blur.native.capture="onChangeCode"-->
                    <a-col :span="11">
                        <a-form-item label="包组编号">
                            <a-input placeholder="包组保存后自动生成"  disabled
                                     v-decorator="['packCode']"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="采购品目">
                            <div class="d-flex">
                                <a-input placeholder="请选择采购品目" disabled  v-decorator="['purchaseTypeName',{rules: [{ required: isRequired, message: '请选择采购品目' }]}]" />
                                <a-button type="primary" @click="openChoosePurchaseTypeMethod">选择</a-button>
                            </div>
                             <a-input  style="display:none"
                                     v-decorator="['purchaseType',{rules: [{ required: isRequired, message: '请选择采购品目' }]}]"></a-input>
                            <!-- <a-input-search placeholder="请选择采购品目"  @search="openChoosePurchaseTypeMethod" v-decorator="['purchaseType',{rules: [{ required: isRequired, message: '请选择采购品目' }]}]" />
                            -->
                            <!--<dict-cascader dictKey="PROJECT.TYPE" placeholder="请选采购品目"
                                           v-decorator="['purchaseType',{rules: [{ required: isRequired, message: '请输入采购品目' }]}]"/>-->
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row type="flex" justify="space-between" class="form-input about">
                    <a-col :span="24">
                        <a-divider class="color-orange" orientation="left">竞价要求</a-divider>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="竞价方式">
                            <a-radio-group @change="e=> jingjiaWayChange(e.target.value)"
                                    v-decorator="['jingjiaWay',{initialValue:initData.jingjiaWay}]">
                                <a-radio value="1">自由竞价</a-radio>
                                <a-radio value="2">单轮竞价</a-radio>
                                <!-- <a-radio value="3">多轮竞价</a-radio> -->
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                      <a-form-item label="报价类型">
                        <a-radio-group  @change="e=> onChangeOfferType(e.target.value,'offerType')"
                            v-decorator="['offerType',{initialValue:initData.offerType}]">
                          <a-radio value="1">金额</a-radio>
                          <a-radio value="2">折扣率</a-radio>
                          <a-radio value="3">下浮率</a-radio>
                        </a-radio-group>
                      </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="竞价类型">
                            <a-radio-group @change="e=> jingjiaTypeChange(e.target.value)"
                                    :disabled="initData.offerType!='1'"
                                    v-decorator="['jingjiaType',{initialValue:initData.jingjiaType}]">
                                <a-radio value="2">竞低价</a-radio>
                                <a-radio value="1">竞高价</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="竞价时长" >
                             <span class="d-inline-block">
                            <a-input-number placeholder="竞价时长" style="width: 250px"
                                            v-decorator="['duration',{ rules: [{ required: isRequired, message: '请输入竞价时长' }]}]"
                                            :min="0"
                                            :precision="0"
                            />
                            </span>
                            <span class="d-inline-block" style="margin-left: 10px">{{initData.jingjiaWay==='1'?'分钟':'分钟'}}</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11"  v-if="initData.jingjiaWay==='2'">
                        <a-form-item label="详细报价表" >
                                <span class="d-inline-block">
                                    <a-radio-group @change="e=> jingjiaDetailChange(e.target.value)"
                                        v-decorator="['jingjiaDetail',{initialValue:initData.jingjiaDetail}]">
                                        <a-radio value="1">需要</a-radio>
                                        <a-radio value="2">不需要</a-radio>
                                    </a-radio-group>
                                </span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11"  v-if="initData.jingjiaWay==='2'">
                        <a-form-item label="报价确认函">
                                <span class="d-inline-block">
                                    <a-radio-group @change="e=> quotationConfirmChange(e.target.value)"
                                        v-decorator="['quotationConfirm',{initialValue:initData.quotationConfirm}]">
                                        <a-radio value="1">需要</a-radio>
                                        <a-radio value="2">不需要</a-radio>
                                    </a-radio-group>
                                </span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11" v-if="initData.jingjiaWay==='1'">
                        <a-form-item label="倒计时时长" >
                              <span class="d-inline-block">
                            <a-input-number placeholder="倒计时时长" style="width: 250px"
                                            v-decorator="['countDown',{ rules: [{ required: isRequired, message: '请输入倒计时时长' }]}]"
                                            :min="0"
                                            :precision="0"
                            />
                                    </span>
                            <span class="d-inline-block" style="margin-left: 10px">分钟</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item v-if="initData.offerType=='1'" :label="initData.jingjiaType==='1'?'最低限价':'最高限价'">
                              <span class="d-inline-block">
                            <a-input-number :placeholder="initData.jingjiaType==='1'?'最低限价':'最高限价'" style="width: 250px"
                                            v-decorator="['priceStart',{ rules: [{ required: isRequired, message: '请输入限价' }]}]"
                                            :min="0"
                                            :precision="2"
                                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            />
                            </span>
                            <span class="d-inline-block" style="margin-left: 10px">元</span>
                        </a-form-item>
                        <a-form-item v-else :label="initData.jingjiaType==='1'?'最低限价':'最高限价'">
                              <span class="d-inline-block">
                            <a-input-number
                                            :placeholder="initData.jingjiaType==='1'?'最低限价':'最高限价'"
                                            style="width: 250px"
                                            v-decorator="['priceStart']"
                                            :min="0"
                                            :precision="2"
                                            :max="100"/>
                            </span>
                          <span class="d-inline-block" style="margin-left: 10px">%</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item :label="initData.jingjiaType==='1'?'加价幅度':'减价幅度'" v-if="initData.jingjiaWay==='1' && initData.offerType=='1'">
                              <span class="d-inline-block">
                            <a-input-number :placeholder="initData.jingjiaType==='1'?'加价幅度':'减价幅度'" style="width: 250px"
                                            v-decorator="['pricePer',{ rules: [{ required: isRequired, message: '请输入价格幅度' }]}]"
                                            :min="0"
                                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            />
                                      </span>
                            <span class="d-inline-block" style="margin-left: 10px">元</span>
                        </a-form-item>
                        <a-form-item v-if="initData.offerType!='1' && initData.jingjiaWay==='1'" :label="initData.jingjiaType==='1'?'加价幅度':'减价幅度'">
                            <span class="d-inline-block">
                                <a-input-number :placeholder="initData.jingjiaType==='1'?'加价幅度':'减价幅度'"
                                                style="width: 250px"
                                                v-decorator="['pricePer',{ rules: [{ required: isRequired, message: '请输入价格幅度' }]}]"
                                                :min="0"
                                                :precision="2"
                                                :max="100"/>
                            </span>
                            <span class="d-inline-block" style="margin-left: 10px">%</span>
                        </a-form-item>
                        <a-form-item label="成交规则" v-if="initData.jingjiaWay==='2' || initData.jingjiaWay==='3'">
                            <a-radio-group
                                    @change="e=> dealRuleChange(e.target.value)"
                                    v-decorator="['dealRule',{initialValue:initData.dealRule}]">
                                <a-radio value="1">先报价者成交</a-radio>
                                <a-radio value="2">系统抽签</a-radio>
                            </a-radio-group>
                        </a-form-item>
                        <span style="color:red" v-if="initData.jingjiaWay=='2' && initData.dealRule=='2'">你选择的是系统抽签，若存在40个以上相同报价情况，请谨慎选择</span>
                    </a-col>
                </a-row>
                <a-row type="flex" justify="space-between" class="form-input about">
                    <a-col :span="24">
                        <a-divider class="color-orange" orientation="left">废标条件</a-divider>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="购标供应商">
                            <span class="d-inline-block" style="margin-right: 10px">不少于</span>
                            <span class="d-inline-block">
                            <a-input-number
                                    v-decorator="['leastSupNum',{initialValue:3, rules: [{ required: isRequired, message: '请输入数量' }]}]"
                                    :min="1"
                                    :precision="0"
                            />
                                 </span>
                            <span class="d-inline-block" style="margin-left: 10px">家</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="报价供应商">
                            <span class="d-inline-block" style="margin-right: 10px">不少于</span>
                           <span class="d-inline-block">
                               <a-input-number
                                               v-decorator="['joinSupNum',{initialValue:1,rules: [{ required: isRequired, message: '请输入数量' }]}]"
                                               :min="1"
                                               :precision="0"
                               />
                           </span>
                            <span class="d-inline-block" style="margin-left: 10px">家</span>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row type="flex" justify="space-between" class="form-input about">
                    <a-col :span="24">
                        <a-divider class="color-orange" orientation="left">相关费用</a-divider>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="平台服务费">
                            <a-radio-group :disabled="xmjn === '2'?false:true" @change="e=> isRegFeeChange(e.target.value)"
                                    v-decorator="['isRegFee',{initialValue:initData.isRegFee}]">
                                <a-radio value="1">缴纳</a-radio>
                                <a-radio value="0">不缴纳</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="平台服务费金额" v-if="initData.isRegFee==='1'">
                            <span class="d-inline-block">
                            <a-input-number placeholder="平台服务费金额" style="width: 250px"
                                            :disabled="xmjn === '2'?false:true"
                                            v-decorator="['regFee',{ initialValue:cgwjsj, rules: [{ required: isRequired, message: '请输入平台服务费金额' }]}]"
                                            :min="0"
                                            :precision="2"
                                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            />
                                 </span>
                            <span class="d-inline-block" style="margin-left: 10px">元</span><span style="color: red" v-show="xmjn === '1'">（按项目收取购标费）</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="保证金">
                            <a-radio-group @change="e=> isPayChange(e.target.value)"
                                           v-decorator="['isPay',{initialValue:initData.isPay}]">
                                <a-radio value="1">缴纳</a-radio>
                                <a-radio value="0">不缴纳</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item v-if="initData.isPay==='1'" label="保证金金额">
                             <span class="d-inline-block">
                            <a-input-number placeholder="保证金金额" style="width: 250px"
                                            v-decorator="['deposit',{ rules: [{ required: isRequired, message: '请输入保证金金额' }]}]"
                                            :min="0"
                                            :precision="2"
                                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            />
                            </span>
                            <span class="d-inline-block" style="margin-left: 10px">元</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="成交服务费">
                            <a-radio-group @change="e=> isServiceChange(e.target.value)"
                                           v-decorator="['isService',{initialValue:initData.isService}]">
                                <a-radio value="1">缴纳</a-radio>
                                <a-radio value="0">不缴纳</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="缴纳者" v-if="initData.isService==='1'">
                            <a-radio-group
                                           v-decorator="['payer',{initialValue:initData.payer}]">
                                <a-radio value="1">成交供应商</a-radio>
                                <a-radio value="2">采购人</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="成交服务费计算" v-if="initData.isService==='1'">
                            <a-radio-group @change="e=> serviceWayChange(e.target.value)"
                                           v-decorator="['serviceWay',{initialValue:initData.serviceWay}]">
                                <a-radio value="1">基准费率</a-radio>
                                <a-radio value="2">基准费率下浮</a-radio>
                                <a-radio value="3">基准费率上浮</a-radio>
                                <a-radio value="4">定额收费</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11" v-if="initData.serviceWay==='2'">
                        <a-form-item label="下浮率" >
                               <span class="d-inline-block">
                            <a-input-number placeholder="下浮率" style="width: 250px"
                                            v-decorator="['rate',{ rules: [{ required: isRequired, message: '请输入下浮率' }]}]"
                                            :min="0"
                                            :precision="2"
                            />
                            </span>
                            <span class="d-inline-block" style="margin-left: 10px">%</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11" v-if="initData.serviceWay==='3'">
                        <a-form-item label="上浮率" >
                             <span class="d-inline-block">
                            <a-input-number placeholder="上浮率" style="width: 250px"
                                            v-decorator="['rate',{ rules: [{ required: isRequired, message: '请输入上浮率' }]}]"
                                            :min="0"
                                            :precision="2"
                            />
                            </span>
                            <span class="d-inline-block" style="margin-left: 10px">%</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="成交服务费金额" v-if="initData.serviceWay==='4'">
                              <span class="d-inline-block">
                            <a-input-number placeholder="成交服务费金额" style="width: 250px"
                                            v-decorator="['servicePrice',{ rules: [{ required: isRequired, message: '请输入金额' }]}]"
                                            :min="0"
                                            :precision="2"
                                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            />
                            </span>
                            <span class="d-inline-block" style="margin-left: 10px">元</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11" v-if="initData.isService==='1'">
                        <a-form-item label="服务费额外计税" >
                            <a-radio-group
                                    v-decorator="['ewjs',{initialValue:initData.ewjs}]">
                                <a-radio value="1">需额外计税</a-radio>
                                <a-radio value="0">不计税</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                </a-row>

                <a-row type="flex" justify="space-between" class="form-input about">
                    <a-col :span="24">
                        <a-divider class="color-orange" orientation="left">标的物信息</a-divider>
                    </a-col>
                    <a-table  style="width: 100%"
                            :dataSource="packItems"
                            :rowKey="record => record.id"
                            :pagination="false">


                        <a-table-column key="indexNum" width="5%" title="序号">
                            <template slot-scope="text,record,index">{{index+1}}</template>
                        </a-table-column>
                        <a-table-column  key="subjectName" width="20%" title="名称" data-index="subjectName">
                            <template slot-scope="text,record">
                                <a-input key="subjectName" :value="record.subjectName" style="margin: -5px 0"
                                         placeholder="名称"
                                         @change="e => onEditPackItem(e.target.value, record.id, 'subjectName')"/>
                            </template>
                        </a-table-column>
                        <a-table-column v-if="tenderType==='1'" key="specifications" width="20%" title="品牌及规格型号"
                                        data-index="specifications">
                            <template slot-scope="text,record">
                                <a-input key="specifications" :value="record.specifications" style="margin: -5px 0"
                                         placeholder="规格型号"
                                         @change="e => onEditPackItem(e.target.value, record.id, 'specifications')"/>
                            </template>
                        </a-table-column>

                        <a-table-column v-if="tenderType==='1'" key="quantity" width="10%" title="数量" data-index="quantity">
                            <template slot-scope="text,record">
                                <a-input-number key="quantity" :value="record.quantity" style="margin: -5px 0;width: 100%"
                                                placeholder="数量" :min="1"
                                                @change="value => onEditPackItem(value, record.id, 'quantity')"/>
                            </template>
                        </a-table-column>
                        <a-table-column v-if="tenderType==='1'" key="unit" width="10%" title="单位" data-index="unit">
                            <template slot-scope="text,record">
                                <a-input key="unit" :value="record.unit" style="margin: -5px 0"
                                         placeholder="单位"
                                         @change="e => onEditPackItem(e.target.value, record.id, 'unit')"/>
                            </template>
                        </a-table-column>
                        <a-table-column v-if="tenderType!=='1'" key="serviceScope" width="25%" :title="(tenderType!=='1' && tenderType==='2')?'施工范围':'简要服务内容'" data-index="serviceScope">
                            <template slot-scope="text,record">
                                <a-input  key="serviceScope" :value="record.serviceScope" style="margin: -5px 0"
                                          @change="e => onEditPackItem(e.target.value, record.id, 'serviceScope')"/>
                            </template>
                        </a-table-column>
                        <a-table-column v-if="tenderType==='2' || tenderType==='3'" key="servicePeriod" width="15%" :title="(tenderType!=='1' && tenderType==='2')?'施工工期':'服务期限'" data-index="servicePeriod">
                            <template slot-scope="text,record">
                                <a-input  key="servicePeriod" :value="record.servicePeriod" style="margin: -5px 0"
                                          @change="e => onEditPackItem(e.target.value, record.id, 'servicePeriod')"/>
                            </template>
                        </a-table-column>
                        <a-table-column key="ask" width="25%" title="其他要求" data-index="ask">
                            <template slot-scope="text,record">
                                <a-input style="margin: -5px 0;width: 100%" :value="record.ask"
                                         placeholder="其他要求"
                                         @change="e => onEditPackItem(e.target.value, record.id, 'ask')"/>
                            </template>
                        </a-table-column>

                        <a-table-column key="operation" width="10%" title="操作">
                            <template slot-scope="text,record">
                                <a-popconfirm title="是否要删除此行？" @confirm="onRemovePackItem(record.id)">
                                    <a>删除</a>
                                </a-popconfirm>
                            </template>
                        </a-table-column>



                        <!--                        <template slot="subjectName" slot-scope="text, record">-->
<!--                            <a-input key="subjectName" :value="record.subjectName" style="margin: -5px 0"-->
<!--                                     placeholder="名称"-->
<!--                                     @change="e => onEditPackItem(e.target.value, record.id, 'subjectName')"/>-->
<!--                        </template>-->
<!--                        <template slot="specifications" slot-scope="text, record">-->
<!--                            <a-input key="specifications" :value="record.specifications" style="margin: -5px 0"-->
<!--                                     placeholder="规格型号"-->
<!--                                     @change="e => onEditPackItem(e.target.value, record.id, 'specifications')"/>-->
<!--                        </template>-->
<!--                        <template slot="quantity" slot-scope="text, record">-->
<!--                            <a-input-number key="quantity" :value="record.quantity " style="margin: -5px 0;width: 100%"-->
<!--                                            placeholder="数量" :min="1"-->
<!--                                            @change="value => onEditPackItem(value, record.id, 'quantity')"/>-->
<!--                        </template>-->
<!--                        <template slot="unit" slot-scope="text, record">-->
<!--                            <a-input style="margin: -5px 0;width: 100%" :value="record.unit" placeholder="单位"-->
<!--                                            @change="e => onEditPackItem(e.target.value, record.id, 'unit')"/>-->
<!--                        </template>-->
<!--&lt;!&ndash;                        <template slot="ask" slot-scope="text, record">&ndash;&gt;-->
<!--&lt;!&ndash;                            <a-input style="margin: -5px 0;width: 100%" :value="record.ask"&ndash;&gt;-->
<!--&lt;!&ndash;                                     @click="e => openEdit(e.target.value,record.id, 'ask')" placeholder="其他要求"&ndash;&gt;-->
<!--&lt;!&ndash;                                     @change="e => onEditPackItem(e.target.value, record.id, 'ask')"/>&ndash;&gt;-->
<!--&lt;!&ndash;                        </template> @click="e => openEdit(e.target.value,record.id, 'remarks')"&ndash;&gt;-->
<!--                        <template slot="ask" slot-scope="text, record">-->
<!--                            <a-input style="margin: -5px 0;width: 100%" :value="record.ask"-->
<!--                                     placeholder="备注"-->
<!--                                     @change="e => onEditPackItem(e.target.value, record.id, 'ask')"/>-->
<!--                        </template>-->
<!--                        <template slot="operation" slot-scope="text, record">-->
<!--                            <a-popconfirm title="是否要删除此行？" @confirm="onRemovePackItem(record.id)">-->
<!--                                <a>删除</a>-->
<!--                            </a-popconfirm>-->
<!--                        </template>-->
                    </a-table>
                    <a-button
                              style="width: 100%; margin-top: 16px; margin-bottom: 8px" type="dashed" icon="plus"
                              @click="onAddPackItem">新增标的物
                    </a-button>
                </a-row>
                <a-row type="flex" justify="space-between" class="form-input about">
                    <a-col :span="24">
                        <a-divider class="color-orange" orientation="left">备注</a-divider>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item label="其他说明">
                            <a-textarea
                                    placeholder="其他说明"
                                    :auto-size="{ minRows: 2, maxRows: 6 }"
                                    v-decorator="['otherRemarks']"/>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
            <div>
<!--                <a-modal-->
<!--                        :title="textModel.rowColumn=='ask'?'其他要求':'备注'"-->
<!--                        v-model="showEditModal"-->
<!--                        @ok="onShowEditModalOk"-->
<!--                >-->
<!--                    <a-form-item :label="textModel.rowColumn=='ask'?'其他要求':'备注'">-->
<!--                        <a-input hidden v-model="textModel.rowId"></a-input>-->
<!--                        <a-input hidden v-model="textModel.rowColumn"></a-input>-->
<!--                        <a-textarea style="height:120px;" v-model="textModel.textMsg"></a-textarea>-->
<!--                    </a-form-item>-->
<!--                </a-modal>-->
            </div>
            <div>
                <a-modal
                        title="标的物删除"
                        v-model="showDelModal"
                        @ok="onShowDelModalOk"
                >
                    <p>至少填写一个标的物！</p>
                </a-modal>
            </div>
            <choose-purchase-type ref="choosePurchaseTypeRef" :visible="choosePurchaseTypeVisible" @success="choosePurchaseTypeSuccessMethod" @cancel="choosePurchaseTypeCancelMethod" ></choose-purchase-type>
        </a-card>
    </page-view>
</template>

<script>
  import { PageView } from '@/layouts'
  import moment from 'moment'
  import DictCascader from '@/components/dict/DictCascader'
  import qs from 'qs'
  import ChoosePurchaseType from './ChoosePurchaseType'

  const uuidv4 = require('uuid/v4')
  export default {
    name: 'PackAdd',
    props: ['visible', 'projectId', 'tenderType','packId','isRequired','indexNum', 'xmmc', 'xmjn', 'cgwjsj'],
    components: {
      PageView,
      DictCascader,
      'choose-purchase-type':ChoosePurchaseType
    },
    data () {
      return {
        choosePurchaseTypeVisible:false,
        projectModel: {},
        // textModel: {
        //   textMsg: '',
        //   rowId: '',
        //   rowColumn: ''
        // },
        //showEditModal: false,
        showDelModal: false,
        nowDtae:moment(),
        packSubDataModel: {},
        initData: {
          ewjs:'1',
          jingjiaWay:'1',
          isRegFee:'1',
          jingjiaType:'2',
          isService: '1',
          offerType: '1',
          serviceWay:'1',
          payer:'1',
          isPay:"1",
          dealRule:'1',
          jingjiaDetail:'2',
          quotationConfirm:'2'
        },
        packForm: this.$form.createForm(this),
        // packId: uuidv4(),
        // columns: [
        //   {
        //     title: '名称',
        //     width: '250px',
        //     scopedSlots: { customRender: 'subjectName' }
        //   },
        //   {
        //     title: '规格型号',
        //     width: '250px',
        //     scopedSlots: { customRender: 'specifications' }
        //   },
        //   {
        //     title: '数量',
        //     width: '100px',
        //     scopedSlots: { customRender: 'quantity' },
        //   },
        //   {
        //     title: '单位',
        //     width: '100px',
        //     scopedSlots: { customRender: 'unit' },
        //   },
        //   // {
        //   //   title: '其他要求',
        //   //   width: '300px',
        //   //   scopedSlots: { customRender: 'ask' },
        //   // },
        //   {
        //     title: '其他说明',
        //     width: '400px',
        //     scopedSlots: { customRender: 'ask' },
        //   },
        //   {
        //     title: '操作',
        //     width: '80px',
        //     scopedSlots: { customRender: 'operation' }
        //   }
        // ],
        packItems: []

      }
    },
    created () {
     // this.onAddPackItem()
      console.log(this.tenderType)
      console.log('xmmc', this.xmmc)
      console.log('cgwjsj', this.cgwjsj)
    },
    watch: {
      tenderType: {
        immediate: true,
        handler (newValue, oldValue) {
          if (newValue !== oldValue) {
            console.log(newValue)
            this.packItems=[]
            this.onAddPackItem()
          }
        }
      }
    },
    methods: {
        //设置报价类型
      onChangeOfferType(val, field){
        if(val=='2'){
            this.initData.jingjiaType = '2'
            this.packForm.setFieldsValue({
                jingjiaType: '2'
            })
        }
        if(val=='3'){
            this.initData.jingjiaType = '1'
            this.packForm.setFieldsValue({
                jingjiaType: '1',
            })
        }
        this.initData[field] = val
      },
      //是的缴纳平台服务费
      isRegFeeChange(val) {
        this.initData.isRegFee = val
      },
      jingjiaTypeChange(val) {
        this.initData.jingjiaType = val
      },
      jingjiaWayChange(val){
        this.initData.jingjiaWay = val
      },
      //是的缴纳成交服务费
      isServiceChange(val) {
        if ("2"===val)
        {
          this.initData.serviceWay =''
        }else {
          this.initData.serviceWay ='1'
        }
          this.initData.isService = val

      },
      //成交服务费缴纳方式
      serviceWayChange(val) {
        this.initData.serviceWay = val
      },
      //是否缴纳保证金
      isPayChange (val) {
        this.initData.isPay = val
      },
      //是否需要详细报价表
      jingjiaDetailChange(val) {
        this.initData.jingjiaDetail = val
      },
      //是否需要上传报价过程确认函
      quotationConfirmChange(val){
        this.initData.quotationConfirm = val
      },
      dealRuleChange(val){
        this.initData.dealRule = val
      },
      // 校验编码入口
      onChangeCode (e) {
        this.checkCode(e.target.value, '1')
      },
      // 校验编码
      checkCode (packCode, val) {
        const arr = []
        let that = this
        that.$http.get('/api/1/apply/checkPackCode.json?packId=' + that.packId + '&packCode=' + packCode).then(function (response) {
          if (response.code !== 200) {
            return
          }
          if (response.result > 0) {
            arr.push({
              message: '您输入的包组编号已存在，请更换!',
              field: 'packCode'
            })
            that.packForm.setFields({ packCode: { value: packCode, errors: arr } })
          } else {
            if (val !== '1') {
              that.saveData()
            }
          }
        })
      },
      //打开弹出框
      // openEdit (value, id, column) {
      //   this.textModel.rowId = id
      //   this.textModel.rowColumn = column
      //   this.textModel.textMsg = value
      //   this.showEditModal = true
      // },
      // onShowEditModalOk () {
      //   this.showEditModal = false
      //   this.onEditPackItem(this.textModel.textMsg, this.textModel.rowId, this.textModel.rowColumn)
      // },
      //添加标的物
      onAddPackItem () {
        this.packItems.push({
          id: uuidv4(),
          subjectName: '',
          specifications: '详见采购需求',
          createTime: moment(),
          quantity: '',
          unit: '',
          ask: '详见采购需求',
          remarks: '',
          serviceScope:'详见采购需求',
          servicePeriod:''
        })
      },
      onShowDelModalOk () {
        this.showDelModal = false
      },
      //删除标的物
      onRemovePackItem (id) {
        //console.log(this.packItems.length)
        if (this.packItems.length < 2) {
          this.showDelModal = true
        } else {
          const newData = this.packItems.filter(item => item.id !== id)
          this.packItems = newData
        }
      },
      //编辑标的物
      onEditPackItem (value, id, column) {
        const newData = [...this.packItems]
        const target = newData.filter(item => id === item.id)[0]
        if (target) {
          target[column] = value
          this.packItems = newData
        }

      },
      //保存包组和标的物
      saveData () {
        const that = this
        let packData = that.packForm.getFieldsValue()
        packData.items = that.packItems
        //console.log(that.packItems)
        for (let i = 0; i < that.packItems.length; i++) {
          that.packItems[i].projectId = that.projectId
          that.packItems[i].packId = that.packId
        }
        packData.id = that.packId
       // packData.createTime=that.nowDtae
        packData.projectId = that.projectId
        // packData.projectCode = that.projectModel.projectCode
        // packData.projectName = that.projectModel.projectName
        // let subMessage =''
        // for (let i = 0; i < packData.items.length ; i++) {
        //   if (!packData.items[i].subjectName || !packData.items[i].specifications || !packData.items[i].quantity || !packData.items[i].unit)
        //   {
        //     subMessage = subMessage+(i+1)+',';
        //   }
        // }
        // if (subMessage)
        // {
        //   that.$message.error('标的物第'+subMessage.substring(0,subMessage.lastIndexOf(','))+'行信息不全，请补全！')
        //   return
        // }
       // console.log(packData)
        this.$http.post('/api/1/apply/addBidPack.json', qs.stringify(packData, { allowDots: true })).then(function (response) {
          if (response.code !== 200) {
            that.$message.error('保存失败')
            return
          }
          that.$message.success(response.msg)
          that.$emit('success')

        })
      },
      //保存
      onSave () {
        let that = this
        that.packForm.validateFields((err, values) => {
          if (err) {
            return
          }
          if (values.joinSupNum>values.leastSupNum)
          {
            that.$message.error('报价供应商家数不能大于购标供应商家数！')
            return
          }
          that.saveData()
        //  that.checkCode(values.packCode)
        })
      },
      reset () {
        this.packForm.resetFields()
        this.model = {}
      },
      //打开选择采购品目的页面
      openChoosePurchaseTypeMethod(){
            this.choosePurchaseTypeVisible=true;
            let json=[];
            let purchaseType=this.packForm.getFieldValue("purchaseType");
            let purchaseTypeName=this.packForm.getFieldValue("purchaseTypeName");
            if(purchaseType){
                let typeNames=purchaseTypeName.split("/");
                let types=purchaseType.split("/");
                for(let i=0;i<types.length;i++){
                    let customJson={
                        "fid":types[i],
                        "fspmmc": typeNames[i]
                    };
                    json.push(customJson);
                }
            }
            this.$refs.choosePurchaseTypeRef.preView(json);
      },
      //采购品目页面成功返回的代码
      choosePurchaseTypeSuccessMethod(userSelectContent){
            let purchaseType="";
            let purchaseTypeName="";
            for(let i=0;i<userSelectContent.length;i++){
                purchaseType+=userSelectContent[i].fid;
                purchaseTypeName+=userSelectContent[i].fspmmc;
                if(i!=userSelectContent.length-1){
                    purchaseType+="/";
                    purchaseTypeName+="/";
                }
            }
             this.packForm.setFieldsValue({
                    purchaseType:purchaseType,
                    purchaseTypeName:purchaseTypeName
            });
             this.choosePurchaseTypeVisible=false;

      },
      //采购品目页面关闭窗口返回的代码
      choosePurchaseTypeCancelMethod(){
            this.choosePurchaseTypeVisible=false;
      },
    }
  }
</script>

<style lang="less" scoped>
    /deep/ .page-header {
        border-bottom: none;
    }

    /deep/ .page-header .breadcrumb {
        display: none;
    }
</style>
